module.exports = __webpack_public_path__ + "media/images/extending-leads-a603a65d.png";